import React, { JSX } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import {
  getMetaMaskProvider,
  registerIotaSnapWallet,
} from '@liquidlink-lab/iota-snap-for-metamask';
import BigNumber from 'bignumber.js';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { Routes } from 'modules/routes';
import { store } from 'modules/store';

import { AppBase } from './modules/layout/components/AppBase';

// https://doc.liquidlink.io/docs/iota-snap
void (async () => {
  try {
    const provider = await getMetaMaskProvider();
    if (provider?.available) {
      registerIotaSnapWallet();
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error while registering IOTA Snap: ', e);
  }
})();

BigNumber.config({
  EXPONENTIAL_AT: [-100, 100],
  DECIMAL_PLACES: 18,
  ROUNDING_MODE: 1,
  FORMAT: {
    decimalSeparator: '.',
    groupSeparator: ' ',
    groupSize: 3,
    secondaryGroupSize: 0,
    fractionGroupSeparator: ' ',
    fractionGroupSize: 0,
  },
});

function App(): JSX.Element {
  return (
    <Provider store={store}>
      <BrowserRouter basename={import.meta.env.VITE_HOMEPAGE}>
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <AppBase>
            <Routes />
          </AppBase>
        </QueryParamProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
